import { init, track } from '@amplitude/analytics-browser';
import memoize from 'lodash/memoize';

export const initializeAmplitude = memoize(() => {
  const platform = window.location.href.includes('platform');
  const key = platform ? 'ec6b10691b75a238ad559d5f7fb32acd' : '4d87c8215351335eeb58f83812aac11f';
  if (!key) return;
  init(key);
});

// eslint-disable-next-line
export const trackEvent = (name: string, data?: any) => {
  track(name, data);
};
